export const SET_STATE = 'checkoutPage/travelers/SET_STATE';
export const SET_TRAVELERS_INITIAL_VALUE = 'checkoutPage/travelers/SET_TRAVELERS_INITIAL_VALUE';
export const SET_TRAVELER_INFORMATION = 'checkoutPage/travelers/SET_TRAVELER_INFORMATION';
export const UPDATE_TRAVELER_INPUT_VALUE_AND_VALIDATE =
  'checkoutPage/travelers/UPDATE_TRAVELER_INPUT_VALUE_AND_VALIDATE';
export const SET_VALIDITY = 'checkoutPage/travelers/SET_VALIDITY';
export const SET_NAMES_SPELLED_CORRECTLY = 'checkoutPage/travelers/SET_NAMES_SPELLED_CORRECTLY';
export const SET_NAMES_SPELLED_CORRECTLY_VISIBLE = 'checkoutPage/travelers/SET_NAMES_SPELLED_CORRECTLY_VISIBLE';
export const RESET_TRAVELERS = 'checkoutPage/travelers/RESET_TRAVELERS';
